<div class="page">
  <div class="page-container">
    <router-outlet></router-outlet>
  </div>
  <app-footer id="outer-footer"></app-footer>
</div>
